// Carry Roll Engine Physical Constants — PSD §4.2
// Ball physical properties (USGA conforming)
export const BALL_MASS = 0.0459; // kg
export const BALL_RADIUS = 0.02135; // m
export const BALL_AREA = Math.PI * BALL_RADIUS * BALL_RADIUS; // m^2
// Gravity
export const G = 9.81; // m/s^2
// Atmosphere
export const RS = 287.058; // specific gas constant for dry air, J/(kg·K)
export const RV = 461.495; // specific gas constant for water vapour, J/(kg·K)
export const LAPSE_RATE = 0.0065; // K/m tropospheric lapse rate
export const SEA_LEVEL_TEMP = 288.15; // K standard sea-level temperature
export const SEA_LEVEL_PRESSURE = 101325; // Pa standard sea-level pressure
export const STD_BAROMETRIC_EXP = 5.2561; // exponent in barometric formula
// Integration
export const DT_FLIGHT = 0.005; // 5 ms flight step
export const DT_ROLL = 0.02; // 20 ms roll step
export const MAX_T = 30; // s flight cap
export const MAX_ROLL = 200; // m roll safety cap
export const ROLL_STOP_V = 0.2; // m/s roll stop threshold
// Density clamp envelope
export const RHO_MIN = 0.4;
export const RHO_MAX = 1.6;
// Aerodynamics
export const SPIN_DECAY_HALFLIFE = 5.0; // s
export const SPIN_FLOOR_RPM = 100; // minimum decayed spin
// Roll friction base by surface
export const FRICTION_BASE = {
    green: 0.45,
    fairway: 0.22,
    rough: 0.35,
};
export const FIRMNESS_FACTOR = {
    firm: 0.6,
    normal: 1.0,
    soft: 1.4,
};
export const MOISTURE_FACTOR = {
    dry: 0.85,
    normal: 1.0,
    wet: 1.5,
};
// Shot-shape thresholds (§4.2.6) — total lateral curvature in degrees
export const SHAPE_STRAIGHT_MAX = 2; // |curve| < 2° → Straight
export const SHAPE_MID_MAX = 8; // 2–8° → draw/fade; >8° → hook/slice
// Trajectory profile thresholds (§4.2.6) — apex/carry ratio
export const PROFILE_LOW_MAX = 0.1; // < 0.10 → Low
export const PROFILE_HIGH_MIN = 0.18; // > 0.18 → High
// Validation ranges (§3.2 constraints)
export const RANGE_BALL_SPEED = [10, 100];
export const RANGE_CLUB_SPEED = [10, 70];
export const RANGE_LAUNCH_ANGLE_RAD = [-0.35, 0.87];
export const RANGE_SPIN_RPM = [0, 15000];
export const RANGE_SMASH = [1.0, 1.55];
export const RANGE_ALTITUDE_M = [0, 4000];
export const RANGE_TEMPERATURE_K = [253, 323];
export const RANGE_WIND_MS = [0, 30];
//# sourceMappingURL=constants.js.map